import nb from './translations/nb.json'
import en from './translations/en.json'
import ru from './translations/ru.json'
import lv from './translations/lv.json'
import ro from './translations/ro.json'
import pl from './translations/pl.json'
import lt from './translations/lt.json'

const messages = {
  nb,
  en,
  ru,
  lv,
  ro,
  pl,
  lt,
  'nb-NO': nb,
  'nn-NO': nb,
  'en-GB': en,
  'en-US': en,
  'ru-RU': ru,
  'lv-LV': lv,
  'ro-RO': ro,
  'pl-PL': pl,
  'lt-LT': lt,
}

type MessagesKey = keyof typeof messages
type TranslationKey = keyof (typeof messages)[MessagesKey]

export default messages as {
  [key in MessagesKey]: {
    [key in TranslationKey]: string
  }
}
